var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"repo_detail"},[_c('v-navigation-drawer',{class:{
      'r-drawer': true,
      'full-width': _vm.docId === undefined
    },attrs:{"app":"","clipped":"","permanent":"","floating":""}},[_c('repo-doc-tree',{attrs:{"id":_vm.id}})],1),(_vm.docId)?_c('div',[_c('doc-detail',{attrs:{"repoId":_vm.id,"id":_vm.id}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }